export const AUTH_CHECK_TOKEN = 'AUTH_CHECK_TOKEN';
export const AUTH_CHECK_TOKEN_SUCCESS = 'AUTH_CHECK_TOKEN_SUCCESS';
export const AUTH_CHECK_TOKEN_ERROR = 'AUTH_CHECK_TOKEN_ERROR';
